import React from 'react';
import { motion } from 'framer-motion';
import { Camera, Clock, Smartphone, FolderOpen, MessageCircle } from 'lucide-react';
export function HeroSection() {
  const scrollToContact = () => {
    document.querySelector('#contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const scrollToHowItWorks = () => {
    document.querySelector('#como-funciona')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-24 pb-16 lg:pt-48 lg:pb-32 overflow-hidden bg-white" data-id="element-85">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-86">
        <div className="lg:grid lg:grid-cols-12 lg:gap-16 items-center" data-id="element-87">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-6 text-center lg:text-left mb-12 lg:mb-0" data-id="element-88">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-89">
              <span className="block text-gray-900" data-id="element-90">Visita la obra.</span>
              <span className="block text-gray-900" data-id="element-91">Envía por WhatsApp.</span>
              <span className="block text-blue-600" data-id="element-92">Informe listo.</span>
            </h1>
            <p className="text-lg sm:text-xl text-gray-600 mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-93">
              InspectIA convierte tus fotos, audios y notas en un informe
              técnico profesional. Automáticamente.
            </p>

            <div className="bg-gray-900 text-white rounded-lg px-5 py-3 inline-flex items-center gap-3 mb-8 mx-auto lg:mx-0 shadow-sm" data-id="element-94">
              <span className="text-red-400 font-bold line-through opacity-75" data-id="element-95">
                2 horas
              </span>
              <span className="text-gray-400" data-id="element-96">→</span>
              <span className="text-green-400 font-bold" data-id="element-97">5 minutos</span>
              <span className="text-gray-300 text-sm" data-id="element-98">por informe</span>
            </div>

            <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-8 max-w-2xl mx-auto lg:mx-0" data-id="element-99">
              <div className="flex items-start sm:items-center text-sm text-gray-600 font-medium" data-id="element-100">
                <Camera className="w-5 h-5 mr-2 text-blue-500 flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-101" />
                <span data-id="element-102">Envía fotos, audios y notas por WhatsApp</span>
              </div>
              <div className="flex items-start sm:items-center text-sm text-gray-600 font-medium" data-id="element-103">
                <Clock className="w-5 h-5 mr-2 text-blue-500 flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-104" />
                <span data-id="element-105">InspectIA organiza tus observaciones</span>
              </div>
              <div className="flex items-start sm:items-center text-sm text-gray-600 font-medium" data-id="element-106">
                <Smartphone className="w-5 h-5 mr-2 text-blue-500 flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-107" />
                <span data-id="element-108">Informe técnico generado automáticamente</span>
              </div>
              <div className="flex items-start sm:items-center text-sm text-gray-600 font-medium" data-id="element-109">
                <FolderOpen className="w-5 h-5 mr-2 text-blue-500 flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-110" />
                <span data-id="element-111">Historial de visitas siempre disponible</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start" data-id="element-112">
              <button onClick={scrollToContact} className="inline-flex justify-center items-center px-5 sm:px-6 py-3 sm:py-3.5 border border-transparent text-sm sm:text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 shadow-sm transition-colors" data-id="element-113">
                Probar InspectIA
              </button>
              <button onClick={scrollToHowItWorks} className="inline-flex justify-center items-center px-5 sm:px-6 py-3 sm:py-3.5 border border-gray-300 text-sm sm:text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 shadow-sm transition-colors" data-id="element-114">
                Ver cómo funciona
              </button>
            </div>
          </motion.div>

          {/* CSS Mockup Illustration */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-6 relative" data-id="element-115">
            <div className="relative w-full max-w-lg mx-auto" data-id="element-116">
              {/* Browser Window Mockup */}
              <div className="bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden relative z-10 ml-4 sm:ml-16" data-id="element-117">
                {/* Browser Header */}
                <div className="bg-gray-50 border-b border-gray-200 px-3 sm:px-4 py-2 sm:py-3 flex items-center gap-2" data-id="element-118">
                  <div className="flex gap-1.5" data-id="element-119">
                    <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-red-400" data-id="element-120"></div>
                    <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-amber-400" data-id="element-121"></div>
                    <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-green-400" data-id="element-122"></div>
                  </div>
                  <div className="mx-auto bg-white border border-gray-200 rounded-md text-[9px] sm:text-[10px] text-gray-400 px-4 sm:px-12 py-1 truncate max-w-[60%]" data-id="element-123">
                    inspectia.app/informe
                  </div>
                </div>

                {/* Browser Content */}
                <div className="p-3 sm:p-5 bg-gray-50/50" data-id="element-124">
                  <div className="flex justify-between items-center mb-3 sm:mb-4" data-id="element-125">
                    <div className="text-xs sm:text-sm font-semibold text-gray-800 truncate mr-2" data-id="element-126">
                      Informe de Visita — Proyecto Centro
                    </div>
                    <div className="flex gap-1 sm:gap-2 flex-shrink-0" data-id="element-127">
                      <span className="px-1.5 sm:px-2 py-0.5 sm:py-1 text-[8px] sm:text-[10px] font-medium bg-white border border-gray-200 rounded-full text-gray-600" data-id="element-128">
                        PDF
                      </span>
                    </div>
                  </div>

                  {/* Report Layout Area */}
                  <div className="relative w-full aspect-[4/3] bg-white border border-gray-200 rounded-lg p-3 sm:p-5 overflow-hidden shadow-sm" data-id="element-129">
                    {/* Report Header */}
                    <div className="border-b border-gray-100 pb-2 mb-3" data-id="element-130">
                      <div className="h-3 w-1/3 bg-gray-800 rounded mb-2" data-id="element-131"></div>
                      <div className="h-2 w-1/4 bg-gray-400 rounded" data-id="element-132"></div>
                    </div>

                    {/* Report Body */}
                    <div className="flex gap-3 sm:gap-4" data-id="element-133">
                      <div className="w-1/3" data-id="element-134">
                        <div className="aspect-square bg-gray-100 rounded-md overflow-hidden border border-gray-200" data-id="element-135">
                          <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=300&h=300&fit=crop" alt="Detalle" className="w-full h-full object-cover" data-id="element-136" />
                        </div>
                      </div>
                      <div className="w-2/3 space-y-2" data-id="element-137">
                        <div className="h-2.5 w-1/2 bg-blue-600 rounded" data-id="element-138"></div>
                        <div className="h-1.5 w-full bg-gray-200 rounded" data-id="element-139"></div>
                        <div className="h-1.5 w-full bg-gray-200 rounded" data-id="element-140"></div>
                        <div className="h-1.5 w-4/5 bg-gray-200 rounded" data-id="element-141"></div>
                      </div>
                    </div>

                    <div className="flex gap-3 sm:gap-4 mt-4" data-id="element-142">
                      <div className="w-1/3" data-id="element-143">
                        <div className="aspect-square bg-gray-100 rounded-md overflow-hidden border border-gray-200" data-id="element-144">
                          <img src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=300&h=300&fit=crop" alt="Detalle" className="w-full h-full object-cover" data-id="element-145" />
                        </div>
                      </div>
                      <div className="w-2/3 space-y-2" data-id="element-146">
                        <div className="h-2.5 w-1/2 bg-blue-600 rounded" data-id="element-147"></div>
                        <div className="h-1.5 w-full bg-gray-200 rounded" data-id="element-148"></div>
                        <div className="h-1.5 w-5/6 bg-gray-200 rounded" data-id="element-149"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* WhatsApp Icon & Connection */}
              <div className="absolute top-1/2 -translate-y-1/2 -left-2 sm:left-0 z-20 flex items-center" data-id="element-150">
                <motion.div animate={{
                y: [0, -5, 0]
              }} transition={{
                repeat: Infinity,
                duration: 3,
                ease: 'easeInOut'
              }} className="w-12 h-12 sm:w-16 sm:h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg border-3 sm:border-4 border-white" data-id="element-151">
                  <MessageCircle className="w-6 h-6 sm:w-8 sm:h-8 text-white fill-current" data-id="element-152" />
                </motion.div>

                {/* Connecting Arrow */}
                <div className="hidden sm:block w-16 h-0.5 bg-blue-300 relative" data-id="element-153">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 border-t-2 border-r-2 border-blue-300 rotate-45" data-id="element-154"></div>
                  <motion.div initial={{
                  scaleX: 0
                }} animate={{
                  scaleX: 1
                }} transition={{
                  repeat: Infinity,
                  duration: 2,
                  ease: 'linear'
                }} className="absolute inset-0 bg-blue-500 origin-left" data-id="element-155"></motion.div>
                </div>
              </div>

              {/* Decorative background elements */}
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-blue-50 rounded-full blur-3xl -z-10" data-id="element-156"></div>
              <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-gray-100 rounded-full blur-3xl -z-10" data-id="element-157"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}